import axios from "axios";
import {
  CREATE_TEMPLE_TRUST_LIST,
  DETAIL_TEMPLE_TRUST_LIST,
  EDIT_TEMPLE_TRUST_LIST,
  TEMPLE_TRUST_LIST,
} from "../../constant/API constant";

export const Temple_Trust_List = (paramsObj) => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(`${process.env.REACT_APP_API_URL}${TEMPLE_TRUST_LIST}`, {
    headers: { Authorization: jwt_token },
    params: paramsObj,
  });
};
export const Create_Temple_Trust_List = (formData) => {
  const jwt_token = localStorage.getItem("token");
  return axios.post(
    `${process.env.REACT_APP_API_URL}${CREATE_TEMPLE_TRUST_LIST}`,
    formData,
    {
      headers: { Authorization: jwt_token },
    }
  );
};

export const Edit_Temple_Trust_List = (formData, trustId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(
    `${process.env.REACT_APP_API_URL}${EDIT_TEMPLE_TRUST_LIST}`,
    formData,
    {
      headers: { Authorization: jwt_token },
      params: { trustId },
    }
  );
};

export const Detail_Temple_Trust_List = (trustId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(
    `${process.env.REACT_APP_API_URL}${DETAIL_TEMPLE_TRUST_LIST}`,
    {
      headers: { Authorization: jwt_token },
      params: { trustId },
    }
  );
};
